<template>
    <div class="r-companies-list-table">
        <r-table
            :columns="columns"
            :items="computedCompanies"
            @onItemClick="handleOnItemClick"
            @onItemChecked="handleOnItemChecked"
        />
        <r-pagination
            :totalPages="totalPages"
            :total="total"
            :currentPage="currentPage"
            @pageChanged="handlePageChanged"
        />
        <company-detail-modal
            :modalName="modalName"
            :company="modalCompany"
        />
    </div>
</template>

<script>
    import Table from '@/components/Table/Table';
    import CompanyDetailModal from '@/components/modals/CompanyDetailModal/CompanyDetailModal';
    import Pagination from '@/components/Pagination/Pagination';

    export default {
        props: {
            selectedCompaniesId: {
                type: Array,
                default: () => [],
            },
            companies: {
                type: Array,
                default: () => [],
            },
            displayItems: {
                type: Number,
                default: 10,
            },
            columns: {
                type: Array,
                default: () => [
                    {
                        name: 'Name',
                        field: 'name',
                        options: {
                            type: 'button'
                        }
                    },
                    {
                        name: 'Country',
                        field: 'country_code_html',
                        options: {
                            type: 'html',
                        },
                    },
                    {
                        name: 'Selected',
                        field: 'selected',
                        options: {
                            type: 'checkbox'
                        }
                    },
                    {
                        name: 'Type',
                        field: 'user_is_input',
                    },
                ],
            }
        },

        data() {
            return {
                itemsPerPage: this.displayItems,
                currentPage: 1,
                modalName: 'company-detail',
                modalCompany: {},
            };
        },

        computed: {
            computedCompanies() {
                const skipCompanies =
                    this.currentPage === 1 ? 0 : (this.currentPage - 1) * this.itemsPerPage;

                return this.companies.map(company => ({
                    ...company,
                    ...{
                        selected: this.selectedCompaniesId.includes(company.id),
                        country_code_html: `<i class="flag flag-${company.country_code.toLowerCase()}"></i>`,
                        user_is_input: company.user_is_input ? 'Input' : 'Output',
                    },
                })).slice(skipCompanies, skipCompanies + this.itemsPerPage);
            },
            total() {
                return this.companies.length;
            },
            totalPages() {
                return Math.ceil(this.total / this.itemsPerPage);
            },
        },

        methods: {
            handleOnItemClick({ item }) {
                this.modalCompany = { ...item };
                this.$modal.show(this.modalName);
            },
            handleOnItemChecked({ item }) {
                const { id, selected } = item;
                let value = [];
                if (selected) {
                    value = this.selectedCompaniesId.filter(company_id => company_id !== id);
                } else {
                    value = [...this.selectedCompaniesId, id];
                }
                this.$emit('onSelectedCompaniesIdChange', value);
            },
            handlePageChanged(page) {
                this.currentPage = page;
            },
        },

        components: {
            'company-detail-modal': CompanyDetailModal,
            'r-table': Table,
            'r-pagination': Pagination,
        }
    };
</script>
